import { MoneyFundLiquidity } from '@products/models/money-fund-liquidity';
import {
  ConfigurationCountry,
  ConfigurationLocale,
  CurrencyCode,
  FundId,
  MoneyFundLiquidityDTO,
  ShareClassCode,
} from '@types';
import { MapperFactory } from './mapper-factory';
import { Mapper, MapperParams } from './type.mapper';

export class MoneyFundLiquiditiesMapper extends Mapper<MoneyFundLiquidity[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    moneyFundLiquidityDTO: MoneyFundLiquidityDTO[]
  ): MoneyFundLiquidity[] {
    const moneyFundLiquidities: MoneyFundLiquidity[] = [];

    moneyFundLiquidityDTO.forEach(
      (moneyFundLiquidityDto: MoneyFundLiquidityDTO) => {
        const moneyFundLiquidity: MoneyFundLiquidity = this.createMapper(
          MoneyFundLiquidityMapper
        ).toDomain(moneyFundLiquidityDto);

        if (moneyFundLiquidity) {
          moneyFundLiquidities.push(moneyFundLiquidity);
        }
      }
    );

    return moneyFundLiquidities;
  }
}

export class MoneyFundLiquidityMapper extends Mapper<MoneyFundLiquidity> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(moneyFundLiquidityDto: MoneyFundLiquidityDTO): MoneyFundLiquidity {
    return {
      fundId: moneyFundLiquidityDto.fundid as FundId,
      shareClassCode: moneyFundLiquidityDto.shclcode as ShareClassCode,
      countryCode: moneyFundLiquidityDto.cntrycode as ConfigurationCountry,
      languageCode: moneyFundLiquidityDto.langcode as ConfigurationLocale,
      currencyCode: moneyFundLiquidityDto.currcode as CurrencyCode,
      asOfDateStd: moneyFundLiquidityDto.asofdatestd,
      asOfDate: moneyFundLiquidityDto.asofdate,
      shadowNav: moneyFundLiquidityDto.shadownav,
      masterFundNav: moneyFundLiquidityDto.masterfundnav,
      amortizedWeeklyLiquidAssetRatio:
        moneyFundLiquidityDto.amrweeklyliquidassetratio,
      amortizedDailyLiquidAssetRatio:
        moneyFundLiquidityDto.amrdailyliquidassetratio,
      amortizedWeeklyLiquidAssetAmount:
        moneyFundLiquidityDto.amrweeklyliquidassetamt,
      amortizedDailyLiquidAssetAmount:
        moneyFundLiquidityDto.amrdailyliquidassetamt,
      marketWeeklyLiquidAssetRatio:
        moneyFundLiquidityDto.mktweeklyliquidassetratio,
      marketDailyLiquidAssetRatio:
        moneyFundLiquidityDto.mktdailyliquidassetratio,
      marketWeeklyLiquidAssetAmount:
        moneyFundLiquidityDto.mktweeklyliquidassetamt,
      marketDailyLiquidAssetAmount:
        moneyFundLiquidityDto.mktdailyliquidassetamt,
      nawp: moneyFundLiquidityDto.nawp,
      maturityWeightedAverage: moneyFundLiquidityDto.matwgtavg,
      lifeWeightedAverage: moneyFundLiquidityDto.lifewgtavg,
      totalSharesOutstanding: moneyFundLiquidityDto.totsharesoutstanding,
      netAssets: moneyFundLiquidityDto.netassets,
      marketTotalNetAssets: moneyFundLiquidityDto.mkttotnetassets,
    };
  }
}
